import { TabView, TabPanel } from "primereact/tabview";
import { getGuid } from "./utility";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import '../components/manualInput/components/competitor/Override.scss'

export interface ITabModel {
    header: string;
    isActive: boolean;
    data?: React.ReactNode;
}

export interface IHoverTabModelProps {
    tabs: ITabModel[];
    label: string;
}

export const HoverTabModel = (props: IHoverTabModelProps) => {
    const targetId = `id-${getGuid().replaceAll('-', '').slice(0, 5)}`;
    const activeTabIndex = props.tabs.findIndex(t => t.isActive);
    const [activeIndex, setActiveIndex] = useState<number>(activeTabIndex === -1 ? 0 : activeTabIndex);
    useEffect(() => {
        setActiveIndex(activeTabIndex === -1 ? 0 : activeTabIndex);
    }, [activeTabIndex]);


    return (
        <>
            <p id={targetId}>{props.label}</p>
            {props.tabs.length > 0 && (
                <Tooltip autoHide={false}
                    target={`#${targetId}`}>
                    <TabView activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e.index)}   >
                        {props.tabs.map((tab, index) => (
                            <TabPanel key={index} header={tab.header}>
                                {tab.data}
                            </TabPanel>
                        ))}
                    </TabView>
                </Tooltip>
            )}
        </>
    );
}   